const news = [
  {
    id: 1,
    title: 'ITMO University and Bosch Launch Research Project in Active Matter Physics',
    link: 'https://www.owler.com/reports/bosch/bosch%E2%80%93itmo-university-and-bosch-launch-research-p/1640176816450',
    resource: 'Owler',
  },
  {
    id: 2,
    title: 'ITMO University and Bosch launch active matter physics research project',
    link: 'https://www.fizicaparticulelor.ro/itmo-university-and-bosch-launch-active-matter-physics-research-project/',
    resource: 'Fizika Particuleror',
  },
  {
    id: 3,
    title: 'ITMO University and Bosch Launch Research Project in Active Matter Physics',
    link: 'https://news.itmo.ru/en/science/photonics/news/12306/',
    resource: 'ITMO.News',
  },
  {
    id: 4,
    title: 'Neural network to study crowd physics for training urban robots',
    link: 'https://techxplore.com/news/2021-06-neural-network-crowd-physics-urban.html',
    resource: 'TechXplore',
  },
  {
    id: 5,
    title: 'ITMO Students Make a Battery That Can Be Wirelessly Recharged up to 500 Times',
    link: 'https://news.itmo.ru/en/science/photonics/news/13044/',
    resource: 'ITMO.News',
  },
  // {
  //   id: 7,
  //   title: 'Ученые ИТМО и Bosch будут проводить исследования в области физики активной материи',
  //   link: 'https://academia.interfax.ru/ru/news/articles/7814?utm_source=yxnews&utm_medium=desktop&utm_referrer=https%3A%2F%2Fyandex.ru%2Fnews%2Fsearch%3Ftext%3D',
  //   resource: 'Интерфакс',
  // },
   // {
  //   id: 8,
  //   title: 'Ученые из Петербурга создадут роботов для Bosch',
  //   link: 'https://www.rbc.ru/spb_sz/20/12/2021/61c0784c9a7947832011b887?from=from_main_3',
  //   resource: 'РБК',
  // },
  // {
  //   id: 9,
  //   title:
  //     'Заживляющая паутина, нанороботы и цифровая машина времени: 8 технологий ИТМО, которые (очень скоро!) изменят будущее',
  //   link: 'https://m.sobaka.ru/city/science/139805',
  //   resource: 'Собака',
  // },
  // {
  //   id: 10,
  //   title: 'Роботы в толпе : Первый шаг к разработке алгоритмов уже сделан',
  //   link: 'https://ug.ru/roboty-v-tolpe/',
  //   resource: 'Учительская газета',
  // },
  // {
  //   id: 11,
  //   title: 'Нейросеть изучит физику толпы для обучения урбанистических роботов',
  //   link: 'https://www.popmech.ru/technologies/730043-neyroset-izuchit-fiziku-tolpy-dlya-obucheniya-urbanisticheskih-robotov/',
  //   resource: 'Популярная Механика',
  // },
  // {
  //   id: 12,
  //   title: 'Создана нейросеть для быстрого обучения коллективно действующих роботов',
  //   link: 'https://berza.ru/royashhihsya-robotov-obuchit-nejroset/',
  //   resource: 'Берза',
  // },
  // {
  //   id: 13,
  //   title: 'О том, как нейросеть исследует физику толпы…',
  //   link: 'https://habr.com/ru/company/misis/blog/565218/',
  //   resource: 'Habr',
  // },
  // {
  //   id: 14,
  //   title: 'Нейросеть изучит физику толпы для обучения урбанистических роботов',
  //   link: 'https://ab-news.ru/2021/06/28/fizika-tolpy/',
  //   resource: 'AB - NEWS',
  // },
  // {
  //   id: 15,
  //   title: 'В России создали нейросеть для быстрого обучения коллективно действующих роботов',
  //   link: 'https://nauka.tass.ru/nauka/11743127',
  //   resource: 'TACC',
  // },
  // {
  //   id: 3,
  //   title: 'Университет ИТМО и Bosch запустили проект в новой научной области',
  //   link: 'https://xn--80afdrjqf7b.xn--p1ai/news/11892/?utm_source=yxnews&utm_medium=desktop&utm_referrer=https%3A%2F%2Fyandex.ru%2Fnews%2Fsearch%3Ftext%3D	',
  //   resource: 'Год науки и технологий',
  // },
];

export default news;
